var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTestTubeDiagonal = function SvgTestTubeDiagonal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "test-tube-diagonal_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#test-tube-diagonal_svg__a)",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.13 5.366a1.25 1.25 0 0 1 0 1.768L6.79 35.474a4.41 4.41 0 0 0 0 6.232 4.41 4.41 0 0 0 6.214.017l.003-.002 28.355-28.355a1.25 1.25 0 0 1 1.767 1.768l-28.36 28.36-.005.005a6.91 6.91 0 0 1-9.742-.025 6.913 6.913 0 0 1 0-9.767l28.34-28.34a1.25 1.25 0 0 1 1.767 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.362 3.366a1.25 1.25 0 0 1 1.767 0l12 12a1.25 1.25 0 1 1-1.767 1.768l-12-12a1.25 1.25 0 0 1 0-1.768ZM6.996 32.25c0-.69.56-1.25 1.25-1.25h16a1.25 1.25 0 0 1 0 2.5h-16c-.69 0-1.25-.56-1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.813 35.962c-1.657-1.657-1.67-4.355-.013-6.012L43.75 27l3.025 3.025a4.207 4.207 0 0 1 0 5.95c-1.643 1.643-4.32 1.63-5.962-.013ZM23.5 32.5H8L4 39l3.5 5H12l11.5-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 23H17L6 35h15.5l12-12Z"
  }))));
};
export default SvgTestTubeDiagonal;